module.exports = __webpack_public_path__ + "img/Logo Sin Fondo.6f478906.png";